import MarketingLayout from '$components/MarketingLayout';
import MailchimpSignup from '$components/MailchimpSignup';
import Hero from '$components/Hero';
import { Flex, Col } from '$components/Flex';
import MarketingSection from '$components/MarketingSection';
import MarketingDivide from '$components/MarketingDivide';
import MarketingCodebox from '$components/MarketingCodebox';
import MarketingBullets from '$components/MarketingBullets';
import postgresPostgraphileGraphql from '$images/postgres_postgraphile_graphql.png';
import Testimonial from '$components/MarketingTestimonial';
import Sponsors, { Sponsor } from '$components/MarketingSponsor';
import chad from '$images/sponsors/chadf.png';
import domonda from '$images/sponsors/domonda.png';
import eighthlight from '$images/sponsors/eighthlight.svg';
import nodesource from '$images/sponsors/nodesource.png';
import openlaw from '$images/sponsors/openlaw.png';
import p72 from '$images/sponsors/p72.png';
import psi from '$images/sponsors/psi.jpg';
import stagency from '$images/sponsors/stagency.png';
import storyscript from '$images/sponsors/storyscript.png';
import timescale from '$images/sponsors/timescale.svg';
import React from 'react';
export default {
  MarketingLayout,
  MailchimpSignup,
  Hero,
  Flex,
  Col,
  MarketingSection,
  MarketingDivide,
  MarketingCodebox,
  MarketingBullets,
  postgresPostgraphileGraphql,
  Testimonial,
  Sponsors,
  Sponsor,
  chad,
  domonda,
  eighthlight,
  nodesource,
  openlaw,
  p72,
  psi,
  stagency,
  storyscript,
  timescale,
  React
};